module.exports = __webpack_public_path__ + "static/foryou-whole-delicious.1b5e1732.jpg";